import React, { useEffect } from "react";
import Intro from './views/Intro';
import Menu from './views/Menu';
import ProgramMode from './views/ProgramMode';
import SelectProgram from './views/SelectProgram';
import LearnMode from './views/LearnMode';
import ManualMode from './views/ManualMode';
import RunMode from './views/RunMode';
import TurnProduct from './views/TurnProduct';
import Layout from './views/Layout'
import Recipes from './views/Recipes'
import RunRecipe from './views/RunRecipe'
// import "./styles/main.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

function App() {
  const [isIntro, setIsIntro] = React.useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsIntro(false);
    }, 2000);
  }, []);

  return (
    <>
      <Router>
        <Switch>
          <Route path="/menu">
            <Menu />
          </Route>
          <Route path="/program">
            <ProgramMode />
          </Route>
          <Route path="/select-program">
            <SelectProgram />
          </Route>
          <Route path="/learn-mode">
            <LearnMode />
          </Route>
          <Route path="/manual-mode">
            <ManualMode />
          </Route>
          <Route path="/turn">
            <TurnProduct />
          </Route>
          <Route path="/run-mode">
            <RunMode />
          </Route>
          <Route path="/run/recipe/:id">
            <RunRecipe />
          </Route>
          <Route path="/layout">
            <Layout />
          </Route>
          <Route path="/recipe/:id">
            <ProgramMode />
          </Route>
          <Route path="/recipes/category/:category">
            <Recipes />
          </Route>
          <Route path="/">
            {isIntro ? <Intro /> : <Menu />}
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
